/**
 * @fileoverview Client-side Supabase client utilities for browser-based auth.
 * Use these utilities in Client Components and client-side operations.
 */

import { createBrowserClient as createSupabaseBrowserClient } from "@supabase/ssr";
import { Database } from "@/types/database";

/**
 * @description Creates a Supabase client for browser-side operations.
 * This client automatically handles session persistence in browser storage
 * and respects RLS policies based on the authenticated user.
 *
 * @example
 * // In a Client Component
 * 'use client';
 * import { createBrowserClient } from '@/lib/supabase/client';
 *
 * export function MyComponent() {
 *   const supabase = createBrowserClient();
 *
 *   const fetchOrders = async () => {
 *     const { data } = await supabase.from('orders').select('*');
 *     return data;
 *   };
 * }
 */
export function createBrowserClient() {
  return createSupabaseBrowserClient<Database>(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
  );
}
